import React from 'react';
import Mailer from './Mailer';

import './Contact.css';

const Contact = () => (
  <div className="app__footer footer__padding" id="contact">
    <div className="app__footer_container">
      <div className="app__footer_contents">
        <Mailer />
      </div>
    </div>
  </div>
);

export default Contact;